/* eslint-disable */
/* istanbul ignore file */
/* THIS FILE IS AUTOGENERATED - DO NOT EDIT */
import * as Types from '@shure/shared/angular/data-access/system-api/core';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ContextMenuCopyEqualizerFilter = {
	id: string;
	description: {
		constraints: {
			gain: { gain: { range: { step: number } } } | null;
			configuration: { filterType: { options: Array<Types.EqFilterType> | null } | null } | null;
		};
	};
	features: {
		bandwidth: { bandwidth: { denominator: number; numerator: number } } | null;
		configuration: { enabled: boolean; filterType: Types.EqFilterType | null } | null;
		frequency: { frequency: number } | null;
		gain: { gain: number } | null;
		qFactor: { qFactor: number } | null;
	};
};

export type ContextMenuCopyChannelFragment = {
	id: string;
	isAudioCopyChannelNode: 'AudioChannel';
	features: {
		autoMute: { enabled: boolean } | null;
		gain: { gain: number } | null;
		mute: { muted: boolean } | null;
		analogLevel: { level: Types.AnalogLevel } | null;
		acousticEchoCancellation: {
			enabled: boolean;
			nonLinearProcessingLevel: Types.NonLinearProcessingLevel | null;
		} | null;
		acousticEchoCancellationMonoReference: { selectedReferenceSource: { id: string } } | null;
		acousticEchoCancellationStereoReference: {
			selectedLeftReferenceSource: { id: string };
			selectedRightReferenceSource: { id: string };
		} | null;
		automaticGainControl: { enabled: boolean; maxBoost: number; maxCut: number; targetLevel: number } | null;
		compressor: { enabled: boolean | null; ratio: number | null; threshold: number | null } | null;
		delay: { delay: string; enabled: boolean } | null;
		equalizer: { filters: Array<ContextMenuCopyEqualizerFilter> } | null;
		deviceSpecificEqualizerContour: { deviceSpecificEqualizerContour: Types.DeviceSpecificEqualizerContour } | null;
		limiter: { bypassed: boolean | null; enabled: boolean; threshold: number | null } | null;
		noiseReduction: { enabled: boolean; level: Types.NoiseReductionLevel | null } | null;
		denoiser: { enabled: boolean; level: Types.DenoiserLevel } | null;
		deverb: { enabled: boolean; intensity: Types.DeverbIntensity } | null;
		inputSource: { source: Types.AudioChannelInputSourceType } | null;
		outputPath: { path: Types.OutputSignalPath } | null;
		passiveSpeakers: { type: Types.SpeakerType } | null;
		pcPeripheral: {
			peripheralOptions: Array<{ id: string; name: string; status: Types.PcPeripheralStatus }>;
			selectedPeripheral: { id: string; name: string; status: Types.PcPeripheralStatus } | null;
		} | null;
		channelBonding: { spatialSeparation: Types.StereoAudioChannelSpatialSeparation } | null;
	};
};

export type GetCopyChannelQueryVariables = Types.Exact<{
	id: Types.Scalars['ID']['input'];
}>;

export type GetCopyChannelQueryOpResult = { node: ContextMenuCopyChannelFragment | {} };

export const ContextMenuCopyEqualizerFilter = gql`
	fragment ContextMenuCopyEqualizerFilter on EqualizerFilter {
		id
		description {
			constraints {
				gain {
					gain {
						range {
							step
						}
					}
				}
				configuration {
					filterType {
						options
					}
				}
			}
		}
		features {
			bandwidth {
				bandwidth {
					denominator
					numerator
				}
			}
			configuration {
				enabled
				filterType
			}
			frequency {
				frequency
			}
			gain {
				gain
			}
			qFactor {
				qFactor
			}
		}
	}
`;
export const ContextMenuCopyChannelFragment = gql`
	fragment ContextMenuCopyChannelFragment on AudioChannel {
		isAudioCopyChannelNode: __typename
		id
		features {
			autoMute {
				enabled
			}
			gain {
				gain
			}
			mute {
				muted
			}
			analogLevel {
				level
			}
			acousticEchoCancellation {
				enabled
				nonLinearProcessingLevel
			}
			acousticEchoCancellationMonoReference {
				selectedReferenceSource {
					id
				}
			}
			acousticEchoCancellationStereoReference {
				selectedLeftReferenceSource {
					id
				}
				selectedRightReferenceSource {
					id
				}
			}
			automaticGainControl {
				enabled
				maxBoost
				maxCut
				targetLevel
			}
			compressor {
				enabled
				ratio
				threshold
			}
			delay {
				delay
				enabled
			}
			equalizer {
				filters {
					...ContextMenuCopyEqualizerFilter
				}
			}
			deviceSpecificEqualizerContour {
				deviceSpecificEqualizerContour
			}
			limiter {
				bypassed
				enabled
				threshold
			}
			noiseReduction {
				enabled
				level
			}
			denoiser {
				enabled
				level
			}
			deverb {
				enabled
				intensity
			}
			inputSource {
				source
			}
			outputPath {
				path
			}
			passiveSpeakers {
				type
			}
			pcPeripheral {
				peripheralOptions {
					id
					name
					status
				}
				selectedPeripheral {
					id
					name
					status
				}
			}
			channelBonding {
				spatialSeparation
			}
		}
	}
	${ContextMenuCopyEqualizerFilter}
`;
export const GetCopyChannelQueryDocument = gql`
	query GetCopyChannelQuery($id: ID!) {
		node(id: $id) {
			...ContextMenuCopyChannelFragment
		}
	}
	${ContextMenuCopyChannelFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class GetCopyChannelQueryGQL extends Apollo.Query<GetCopyChannelQueryOpResult, GetCopyChannelQueryVariables> {
	override document = GetCopyChannelQueryDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
